import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfOutboundElevationIconProps extends SvgIconProps {}

/**
 * Function is used to display svg icon of outbound elevation
 * @param props -CcfOutboundElevationIconProps
 * @returns svg icons of outbound elevation
 * @example <CcfOutboundElevationIcon/>
 */
export function CcfOutboundElevationIcon(props: CcfOutboundElevationIconProps) {
  return (
    <SvgIcon width="20" height="22" viewBox="0 0 20 22" fill="none" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 2C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4C3.55228 4 4 3.55228 4 3C4 2.44772 3.55228 2 3 2ZM0 3C0 1.34315 1.34315 0 3 0C4.30622 0 5.41746 0.834808 5.82929 2L14.1707 2C14.5825 0.834807 15.6938 0 17 0C18.6569 0 20 1.34315 20 3C20 4.65685 18.6569 6 17 6C15.6938 6 14.5825 5.16519 14.1707 4L11 4V10H14.1707C14.5825 8.83481 15.6938 8 17 8C18.6569 8 20 9.34315 20 11C20 12.6569 18.6569 14 17 14C15.6938 14 14.5825 13.1652 14.1707 12H11V14.2C11 15.0566 11.0008 15.6389 11.0376 16.089C11.0734 16.5274 11.1383 16.7516 11.218 16.908C11.4097 17.2843 11.7157 17.5903 12.092 17.782C12.2484 17.8617 12.4726 17.9266 12.911 17.9624C13.2412 17.9894 13.6425 17.997 14.171 17.9992C14.5831 16.8344 15.6941 16 17 16C18.6569 16 20 17.3431 20 19C20 20.6569 18.6569 22 17 22C15.6935 22 14.5821 21.1648 14.1705 19.9993C13.6232 19.9971 13.1515 19.9888 12.7482 19.9558C12.1861 19.9099 11.6694 19.8113 11.184 19.564C10.4314 19.1805 9.81947 18.5686 9.43597 17.816C9.18868 17.3306 9.09012 16.8139 9.04419 16.2518C8.99998 15.7106 8.99999 15.0463 9 14.2413V4L5.82929 4C5.41746 5.16519 4.30622 6 3 6C1.34315 6 0 4.65685 0 3ZM17 2C16.4477 2 16 2.44771 16 3C16 3.55228 16.4477 4 17 4C17.5523 4 18 3.55228 18 3C18 2.44772 17.5523 2 17 2ZM17 10C16.4477 10 16 10.4477 16 11C16 11.5523 16.4477 12 17 12C17.5523 12 18 11.5523 18 11C18 10.4477 17.5523 10 17 10ZM17 18C16.4477 18 16 18.4477 16 19C16 19.5523 16.4477 20 17 20C17.5523 20 18 19.5523 18 19C18 18.4477 17.5523 18 17 18Z"
        fill="#007AB8"
      />
    </SvgIcon>
  );
}

export default CcfOutboundElevationIcon;
